import React, {Component} from 'react';
import Form from 'react-bootstrap/Form'

// wants interval and onChange
export default class Rollup extends Component {
  constructor(props) {
    super(props);
 
    this.state = {
      rollup: this.props?.interval ?? 'none',
    }
    this.rollClick = this.rollClick.bind(this);
  }
  rollClick (evt) {
    this.setState ({rollup: evt.currentTarget.value})
    this.props?.onChange(evt.currentTarget.value)
  }
  render() {
    return (
    <Form style={{width:"10em"}}>
      <Form.Check inline type='radio' id='rollupn' label="None" value="none" 
        checked={this.state.rollup === 'none'} onChange={this.rollClick}/>
      <Form.Check inline type='radio' id='rollup1' label="Daily" value="daily"
        checked={this.state.rollup === 'daily'} onChange={this.rollClick}/>
      <Form.Text muted>&nbsp;&nbsp;Reading rollup</Form.Text>
    </Form>
    )
  }
}
